module.exports = __webpack_public_path__ + "static/media/plus_delta.54bee199.png";